module.exports = __webpack_public_path__ + "media/fonts/ppneuemachina-regular-webfont-efec27bf35d60896bbd3f002d86fd890.woff2";